<template>
<div class="px-2">
    <v-row class="py-2">
        <v-col cols="4">
            <div class="im-label">{{ $t('reservations.modal.rooms') }}</div>
            <div class="mt-1 mb-2">
                <span>{{ item.rooms.length }} </span>
            </div>
        </v-col>
        <v-col cols="4">
            <div class="im-label text-capitalize">{{ $t('reservations.modal.nights') }}</div>
            <div class="mt-1 mb-2">
                <span>{{ item.nights }}</span>
            </div>
        </v-col>
        <v-col cols="4">
            <div class="im-label">{{ $t('reservations.modal.no_guests') }}</div>
            <div class="mt-1 mb-2">
                <span>{{ item.pax.adults }} </span>
            </div>
        </v-col>
    </v-row>

    <div :class="['d-flex', item.channel == 'Booking'?'justify-space-between':'justify-end']">

        <slot name="commision"></slot>

        <div class="pr-2">
            <div class="im-label">{{ $t('reservations.modal.total_price') }}</div>
            <div class="important mt-1 mb-2">
                <im-price :price="item.pricing.total" :currency="item.pricing.currency" fontSize="20" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";
import IMPrice from '../../../small-components/IMPrice.vue';

export default {
    components: {
        'im-price': IMPrice,
    },

    props: {
        item: {
            type: Object,
            default: function () {
                return defaults.reservation_item
            }
        },
    },
    data() {
        return {
            show_invoice: false,
        }
    },
    methods: {

        getFullDate(date) {
            if(!date) return date;
            // let value = date * 1000;
            return this.$moment(date)
                .locale(this.$vuetify.lang.current)
                .format('ddd, DD MMM YY');
        },

        openModalCC() {
            this.$emit('openModalCC')
        },
        openModalInvoice() {
            this.$emit('openModalInvoice')
        }

    },
}
</script>
